module.exports = __webpack_public_path__ + "img/progress-striped-bg.png";